import { render, staticRenderFns } from "./print-detail.vue?vue&type=template&id=2e366523&scoped=true"
import script from "./print-detail.vue?vue&type=script&lang=js"
export * from "./print-detail.vue?vue&type=script&lang=js"
import style0 from "./print-detail.vue?vue&type=style&index=0&id=2e366523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e366523",
  null
  
)

export default component.exports